var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_7498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1042 12.3646C20.7396 12.1563 20.2708 12.1563 19.8542 12.3646L16.9375 14.0833L14.9583 15.1771L12.0937 16.8958C11.7292 17.1042 11.2604 17.1042 10.8437 16.8958L8.60417 15.5417C8.23958 15.3333 7.97917 14.9167 7.97917 14.4479V11.8438C7.97917 11.4271 8.1875 11.0104 8.60417 10.75L10.8437 9.44793C11.2083 9.23959 11.6771 9.23959 12.0937 9.44793L14.3333 10.8021C14.6979 11.0104 14.9583 11.4271 14.9583 11.8958V13.6146L16.9375 12.4688V10.6979C16.9375 10.2813 16.7292 9.86459 16.3125 9.60418L12.1458 7.15626C11.7812 6.94793 11.3125 6.94793 10.8958 7.15626L6.625 9.65626C6.20833 9.86459 6 10.2813 6 10.6979V15.5938C6 16.0104 6.20833 16.4271 6.625 16.6875L10.8437 19.1354C11.2083 19.3438 11.6771 19.3438 12.0937 19.1354L14.9583 17.4688L16.9375 16.3229L19.8021 14.6563C20.1667 14.4479 20.6354 14.4479 21.0521 14.6563L23.2917 15.9583C23.6562 16.1667 23.9167 16.5833 23.9167 17.0521V19.6563C23.9167 20.0729 23.7083 20.4896 23.2917 20.75L21.1042 22.0521C20.7396 22.2604 20.2708 22.2604 19.8542 22.0521L17.6146 20.75C17.25 20.5417 16.9896 20.125 16.9896 19.6563V17.9896L15.0104 19.1354V20.8542C15.0104 21.2708 15.2187 21.6875 15.6354 21.9479L19.8542 24.3958C20.2187 24.6042 20.6875 24.6042 21.1042 24.3958L25.3229 21.9479C25.6875 21.7396 25.9479 21.3229 25.9479 20.8542V15.9063C25.9479 15.4896 25.7396 15.0729 25.3229 14.8125L21.1042 12.3646Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_7498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.4479,
    fill: "white",
    transform: "translate(6 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/MATIC.0bf7391027f6513a7699a011ab425be3.svg";
export { ForwardRef as ReactComponent };